import React, { useState } from "react";
import './index.css';
import '../Banner/Banner.css';
import { Container, Row, Button, Modal, ModalBody } from "react-bootstrap";
// import useFormModal from "../Utils/useFormModal";
import SignUpForm from "../SignupForm/SignupForm";
const WhatIsCribEquity = ({ data }) => {
  const { title, advantages, keyTerms, applyNowBtn, getStartedBtnLink } = data?.whatIsCribEquity;
  const [showForm, setShowForm] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailModal, setShowFailModal] = useState(false);
  const [validated, setValidated] = useState(false);
  let prevScrollPos = window.scrollY;
  const handleFailClose = () => {
    setShowFailModal(false);
    setValidated(false);
  };
  const handleSuccessClose = () => {
    setShowSuccessModal(false);
    setValidated(false);
  };

  const handleShowForm = () => {
    setShowForm(true);
  };
  const handleCloseForm = () => {
    setShowForm(false);
  };

  const handleContactUsClick = () => {
    setShowForm(true);
  };
  return (
    <section id="program-highlights">
      <Container>
        <Row>
          <div className="btn-div-apply">
            <button className="apply-now-btn" onClick={handleContactUsClick}>{applyNowBtn}</button>
          </div>

          <div className="crib-equity-section">
            <div className='text-center whatistext'>
              <p>{title}</p>
            </div>
            <div className="crib-equity-content">

              <div className="crib-advantages">
                <ul>
                  {advantages.map((adv, index) => (
                    <li key={index}>{adv}</li>
                  ))}
                </ul>
              </div>

              <div className="crib-key-terms">
                <ul>
                  {keyTerms.map((term, index) => (
                    <li key={index} className="list-item">{term}</li>
                  ))}
                </ul>
              </div>

            </div>
          </div>
        </Row>
      </Container>
      <Modal backdrop="static" centered show={showForm} onHide={handleCloseForm} size="lg">
        <Modal.Header closeButton onClick={handleCloseForm}>
          <Modal.Title>Please fill the information below to continue</Modal.Title>
        </Modal.Header>
        <ModalBody className='form-modal'>
          <SignUpForm closeForm={handleCloseForm} requestFromModal={true} setShowSuccessModal={setShowSuccessModal} setShowFailModal={setShowFailModal} />
        </ModalBody>
      </Modal>
      <Modal
        size="lg"
        centered
        show={showSuccessModal}
        onHide={handleSuccessClose}
        backdrop="static"
      >
        <Modal.Header closeButton />
        <Modal.Body className="text-center">
          <p className="thanktext m-4">Thank you for your interest. One of our representatives will contact you shortly. We look forward to serving you!</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleSuccessClose}>Close</Button>
        </Modal.Footer>
      </Modal>
      <Modal
        size="lg"
        centered
        show={showFailModal}
        onHide={handleFailClose}
        backdrop="static"
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <p className="thanktext">
            Due to technical difficulties your request could not be processed.
            Please contact us at&nbsp;
            <a href={"mailto:inquiry@swmc.com"} className="form-link">
              inquiry@swmc.com
            </a>
            .
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleFailClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
};

export default WhatIsCribEquity;